import { Grid, MenuItem, Stack } from "@mui/material";
import { SportCourt } from "apis/SportCourtAPI";
import AutocompleteInputContact from "components/AutocompleteContactInput";
import ChipLightSelect from "components/ChipLightSelect";
import LightSelect from "components/LightSelect";
import { useCalendarDispatch } from "components/calendar/context/CalendarContext";
import {
  changeFilterCustomer,
  changeFilterSportCourt,
  changeFilterStatus,
} from "components/calendar/context/utils";
import { FC, useEffect, useState } from "react";
import SportCourtReduxWorker from "store/workers/SportCourtReduxWorker";

export const SCHEDULE_STATUS_FILTER = [
  { name: "Todos", value: "ALL" },
  { name: "Confirmado", value: "CONFIRMED" },
  { name: "Cancelado", value: "CANCELED" },
  { name: "Pago", value: "PAID" },
];

type ContactOption = {
  id: string;
  name: string;
};

const ScheduleFilter: FC = () => {
  const calendarDispatch = useCalendarDispatch();

  const [sportCourts, setSportCourts] = useState<SportCourt[]>([]);
  const [sportCourtIds, setSportCourtIds] = useState<string[]>([]);
  const [statusSelected, setStatusSelected] = useState<string>(
    SCHEDULE_STATUS_FILTER[0].value
  );

  const handleChangeSportCourtIds = (value: string | string[]) => {
    const selectedIds = typeof value === "string" ? value.split(",") : value;
    setSportCourtIds(selectedIds);
    changeFilterSportCourt(calendarDispatch, selectedIds);
  };

  const handleChangeStatus = (value: string) => {
    setStatusSelected(value);
    changeFilterStatus(calendarDispatch, value);
  };

  const handleChangeCustomer = (value: ContactOption | null) => {
    changeFilterCustomer(calendarDispatch, value?.id || "");
  };

  useEffect(() => {
    const sportCourtsFromRedux = SportCourtReduxWorker.getActiveSportCourts();
    if (sportCourtsFromRedux) setSportCourts(sportCourtsFromRedux);
  }, []);

  return (
    <Stack>
      <Grid container spacing={2.2}>
        <Grid item md={4} xs={12}>
          <LightSelect
            labelId="statusLabel"
            id="status"
            name="status"
            label="Status"
            value={statusSelected}
            onChange={(event) => handleChangeStatus(String(event.target.value))}
          >
            {SCHEDULE_STATUS_FILTER.map((scheduleStatus) => (
              <MenuItem key={scheduleStatus.value} value={scheduleStatus.value}>
                {scheduleStatus.name}
              </MenuItem>
            ))}
          </LightSelect>
        </Grid>

        <Grid item md={4} xs={12}>
          <ChipLightSelect
            labelId="sportCourtIdsLabel"
            id="sportCourtIds"
            name="sportCourtIds"
            label="Quadras"
            value={sportCourtIds}
            advancedOptions={sportCourts.map((sportCourt: SportCourt) => ({
              value: sportCourt.id.toString(),
              label: sportCourt.name,
            }))}
            onChange={(event) =>
              handleChangeSportCourtIds(event.target.value as string | string[])
            }
          />
        </Grid>

        <Grid item md={4} xs={12}>
          <AutocompleteInputContact onHandleChange={handleChangeCustomer} />
        </Grid>
      </Grid>
    </Stack>
  );
};

export default ScheduleFilter;
